import { Text, TextProps } from "@chakra-ui/react";
import format from "string-template";

export interface copyrightProps {
  text: string | null | undefined;
  format?: TextProps;
}

export type Copyright_T = TextProps;

export const Copyright = ({ children, ...props }: TextProps) => {
  const text =
    typeof children === "string"
      ? format(children.toString().replace(/%(.*)%/g, "{$1}"), {
          year: String(new Date().getFullYear()),
        })
      : children;
  return (
    <Text
      alignSelf={{ base: "center", lg: "start" }}
      textAlign={{ base: "center", lg: "left" }}
      fontSize="sm"
      {...props}
    >
      {text}
    </Text>
  );
};
